module.exports = __webpack_public_path__ + "static/media/poll-h_active_circle.e6fa8e35.svg";